import React from 'react';
import axios from 'src/common/axiosInstance';
import PersonMemoryEditor from './PersonMemoryEditor';

export default function AiContactMemory({contactId}) {
  const path = `/contacts/${contactId}/ai/memory`;
  return <PersonMemoryEditor resourceKey={`contact:${contactId}`}
    load={async () => (await axios.get(path)).data}
    save={async payload => (await axios.put(path,payload)).data}/>;
}
